<template>
  <div class="search-filter-results-loading">
    <div class="search-filter-results-top-row">
      <div class="search-filter-stats-and-sorting">
        <SearchStats stats-text="jobs" :number-of-hits="42" />
      </div>
      <div class="search-filter-all-filter-reset">
        <ResetFiltersButton disabled label="Clear all filters" />
      </div>
    </div>
    <div class="ais-InfiniteHits">
      <ol class="ais-InfiniteHits-list">
        <li
          v-for="(result, index) in numberOfResults"
          :key="index"
          class="ais-InfiniteHits-item"
        >
          <div class="loading-result-item">
            <ResultItem
              is-loading
              :job-search-global="jobSearchGlobal"
              :item="{}"
            />
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import SearchStats from "../SearchStats/SearchStats.vue";
import ResetFiltersButton from "../ResetFiltersButton/ResetFiltersButton.vue";
import ResultItem from "../ResultItem/ResultItem.vue";
import jobSearchGlobal from "../../../globalSettingProps/jobSearchDefaultGlobalProp.js";

export default {
  name: "ResultsLoading",
  components: { ResultItem, ResetFiltersButton, SearchStats },
  props: {
    jobSearchGlobal: {
      type: Object,
      default() {
        return jobSearchGlobal;
      },
    },
    numberOfResults: {
      type: Number,
      default: 10,
    },
  },
};
</script>

<style lang="scss" scoped>
.search-filter-results-loading {
  opacity: 0.5;
  filter: blur(5px);
}
</style>
